export { default } from './ProductItemDescriptions'
